/**
 * X6 Marketing Section - Motion / Animation Layer
 * All DOM queries are scoped to .x6-marketing-wrapper.
 * The inertia scroll hijacking from the standalone page has been removed
 * to avoid interfering with Shopify's native scrolling behaviour.
 */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.x6-marketing-wrapper');
  if (!wrapper) return;

  var motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Tag sections & reveal items with motion classes ── */
  wrapper.querySelectorAll('section').forEach(function (section) {
    section.classList.add('motion-section');
    section.querySelectorAll('.reveal').forEach(function (item, index) {
      item.style.setProperty('--motion-delay', Math.min(index * 85, 255) + 'ms');
    });
  });

  wrapper.querySelectorAll('h2, h3').forEach(function (heading) {
    if (!heading.closest('.faq-list')) {
      heading.classList.add('motion-heading');
    }
  });

  /* ── Motion media (images with clip-path reveal) ───── */
  var motionMedia = wrapper.querySelectorAll([
    '.product-visual img',
    '.feature-photo > img',
    '.space-story-image img',
    '.gift-card > img',
    '.spec-overview > img',
    '.box-grid img'
  ].join(','));

  motionMedia.forEach(function (media) {
    media.classList.add('motion-media');
    if (media.parentElement) media.parentElement.classList.add('motion-media-frame');
  });

  /* ── Section visibility observer ───────────────────── */
  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('motion-section-visible', entry.isIntersecting);
    });
  }, {
    rootMargin: '-8% 0px -12% 0px',
    threshold: 0.06
  });

  wrapper.querySelectorAll('.motion-section').forEach(function (section) {
    sectionObserver.observe(section);
  });

  /* ── Media reveal observer ─────────────────────────── */
  var mediaObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('motion-media-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.12
  });

  motionMedia.forEach(function (media) { mediaObserver.observe(media); });

  /* ── Parallax ──────────────────────────────────────── */
  var parallaxItems = [
    wrapper.querySelector('.impact-section > img'),
    wrapper.querySelector('.kids-section > img'),
    wrapper.querySelector('.home-section > img')
  ].filter(Boolean);

  parallaxItems.forEach(function (item) {
    item.dataset.motionParallax = '';
  });

  var heroMotionImage = wrapper.querySelector('.hero-image');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  var smoothVelocity = 0;
  var lastFrameScroll = window.scrollY;

  function updateParallax(scrollY) {
    if (motionReduced || window.innerWidth <= 820) return;

    var viewportCenter = window.innerHeight / 2;

    parallaxItems.forEach(function (item) {
      var section = item.closest('section');
      var rect = section.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > window.innerHeight + 120) return;

      var itemCenter = rect.top + rect.height / 2;
      var offset = clamp((viewportCenter - itemCenter) * 0.052 + smoothVelocity * 0.35, -38, 38);
      item.style.setProperty('--motion-parallax-y', offset.toFixed(2) + 'px');
    });

    if (heroMotionImage) {
      var heroRect = heroMotionImage.getBoundingClientRect();
      if (heroRect.bottom > 0) {
        var offset = clamp(scrollY * 0.075, 0, 48);
        var velocityScale = clamp(Math.abs(smoothVelocity) * 0.0007, 0, 0.018);
        heroMotionImage.style.transform =
          'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(' + (1.015 + velocityScale).toFixed(4) + ')';
      }
    }
  }

  /* ── Animation frame loop (parallax only, no scroll hijack) ── */
  function motionFrame() {
    var rawVelocity = window.scrollY - lastFrameScroll;
    smoothVelocity += (rawVelocity - smoothVelocity) * 0.18;
    lastFrameScroll = window.scrollY;

    wrapper.style.setProperty('--motion-velocity', smoothVelocity.toFixed(3));
    updateParallax(window.scrollY);
    requestAnimationFrame(motionFrame);
  }

  requestAnimationFrame(motionFrame);
});
